import React, { useState } from 'react';
import { 
  ChevronLeft, 
  ChevronRight, 
  Send, 
  BookOpen, 
  User, 
  Phone, 
  Mail, 
  Building, 
  FileText, 
  Calendar, 
  Mic, 
  Loader2,
  CheckCircle,
  Sparkles
} from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VIUBUX_LOGO = 'https://customer-assets.emergentagent.com/job_libro-quote-gen/artifacts/pf9umyn8_5.png';

const COUNTRIES = [
  "México", "Estados Unidos", "España", "Argentina", "Colombia", "Chile", "Perú", 
  "Venezuela", "Ecuador", "Guatemala", "Cuba", "Bolivia", "Honduras", "Paraguay",
  "El Salvador", "Nicaragua", "Costa Rica", "Panamá", "Uruguay", "Puerto Rico",
  "República Dominicana", "Otro"
];

const GENRES = [
  "Novela", "Cuento", "Poesía", "Ensayo", "Biografía", "Autobiografía", 
  "Historia", "Ciencia Ficción", "Fantasía", "Romance", "Misterio", "Terror",
  "Autoayuda", "Negocios", "Educativo", "Infantil", "Juvenil", "Religioso",
  "Filosofía", "Psicología", "Otro"
];

const SECTION_OPTIONS = [
  { value: "inicio", label: "Si, debe incluirse al inicio" },
  { value: "final", label: "Si, pero debe incluirse al final" },
  { value: "no", label: "No se debe incluir / No hay" }
];

const GRAPHIC_OPTIONS = [
  { value: "adaptar", label: "Si hay, adaptarlos al formato de audiolibro" },
  { value: "no_incluir", label: "Si hay, pero no se deben incluir" },
  { value: "no_hay", label: "No se debe incluir / No hay" }
];

const NARRATOR_GENDER = [
  { value: "hombre", label: "Hombre" },
  { value: "mujer", label: "Mujer" }
];

const AGE_RANGES = [
  "De 5 a 10 años", "De 10 a 15 años", "De 15 a 22 años", "De 22 a 30 años",
  "De 30 a 40 años", "De 40 a 55 años", "De 55 a 65 años", "65+"
];

const VOICE_TONES = [
  "Alegre", "Formal", "Neutro"
];

const VOICE_TYPES = [
  "Suave", "Aguda", "Cálida", "Relajante", "Rústica", "Tenor", 
  "Grave", "Levemente afónica", "Infantil", "Robótica / AI"
];

const READING_STYLES = [
  "Novelista", "Ejecutivo", "Educativo", "Informativo", "Romántico",
  "Infantil", "Misterioso", "Robótico", "Amigable", "Neutro",
  "Inspirador", "Relajante", "Dramático", "Emocionante", "Sensible"
];

const READING_RHYTHMS = [
  "Acelerado", "Normal", "Pausado"
];

const LANGUAGES = ["Español", "Inglés", "Francés", "Italiano", "Portugués", "Alemán", "Otro"];

const KNOWLEDGE_LEVELS = ["Básico", "Intermedio", "Avanzado"];

function SelectField({ label, value, onChange, options, placeholder = "- Selecciona una opción -" }) {
  return (
    <div className="space-y-2">
      <Label className="text-white text-sm">{label}</Label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-[#aa2aff] focus:border-transparent"
      >
        <option value="" className="bg-[#0f133a]">{placeholder}</option>
        {options.map((opt, idx) => (
          <option key={idx} value={typeof opt === 'object' ? opt.value : opt} className="bg-[#0f133a]">
            {typeof opt === 'object' ? opt.label : opt}
          </option>
        ))}
      </select>
    </div>
  );
}

function TextField({ label, value, onChange, placeholder, type = "text", required = false }) {
  return (
    <div className="space-y-2">
      <Label className="text-white text-sm">
        {label} {required && <span className="text-red-400">*</span>}
      </Label>
      <Input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="bg-white/10 border-white/20 text-white placeholder:text-slate-500"
      />
    </div>
  );
}

function TextAreaField({ label, value, onChange, placeholder, rows = 3 }) {
  return (
    <div className="space-y-2">
      <Label className="text-white text-sm">{label}</Label>
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className="bg-white/10 border-white/20 text-white placeholder:text-slate-500 resize-none"
      />
    </div>
  );
}

export function MetaproduccionForm() {
  const [currentStep, setCurrentStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  // Step 1: Basic Info
  const [formType, setFormType] = useState('basica');
  const [titulo, setTitulo] = useState('');
  const [autor, setAutor] = useState('');
  const [telefono, setTelefono] = useState('');
  const [email, setEmail] = useState('');
  const [registroObra, setRegistroObra] = useState('');
  const [rfc, setRfc] = useState('');
  const [calle, setCalle] = useState('');
  const [colonia, setColonia] = useState('');
  const [ciudad, setCiudad] = useState('');
  const [estado, setEstado] = useState('');
  const [codigoPostal, setCodigoPostal] = useState('');
  const [pais, setPais] = useState('');
  
  // Step 2: Book Info
  const [fechaEntregaPdf, setFechaEntregaPdf] = useState('');
  const [fechaLanzamiento, setFechaLanzamiento] = useState('');
  const [generoObra, setGeneroObra] = useState('');
  const [sinopsis, setSinopsis] = useState('');
  const [cantidadHojas, setCantidadHojas] = useState('');
  const [cantidadPalabras, setCantidadPalabras] = useState('');
  const [editor, setEditor] = useState('');
  const [presentacion, setPresentacion] = useState('');
  const [prologo, setPrologo] = useState('');
  const [introduccion, setIntroduccion] = useState('');
  const [citasInicio, setCitasInicio] = useState('');
  const [dedicatorias, setDedicatorias] = useState('');
  const [elementosGraficos, setElementosGraficos] = useState('');
  const [palabrasOtrosIdiomas, setPalabrasOtrosIdiomas] = useState('');
  const [idiomasIncluidos, setIdiomasIncluidos] = useState([]);
  const [pronunciacionCorrecta, setPronunciacionCorrecta] = useState('');
  const [contextoHistorico, setContextoHistorico] = useState('');
  const [bibliografia, setBibliografia] = useState('');
  const [citasPie, setCitasPie] = useState('');
  
  // Step 3: Voice Selection
  const [generoNarrador, setGeneroNarrador] = useState('');
  const [rangoEdad, setRangoEdad] = useState('');
  const [tonoIntencion, setTonoIntencion] = useState('');
  const [tipoVoz, setTipoVoz] = useState('');
  const [estiloLectura, setEstiloLectura] = useState('');
  const [ritmoLectura, setRitmoLectura] = useState('');
  const [cantidadPersonajes, setCantidadPersonajes] = useState('');
  const [acentosPersonajes, setAcentosPersonajes] = useState('');
  const [especificacionAcentos, setEspecificacionAcentos] = useState('');
  const [conocimientoIdioma, setConocimientoIdioma] = useState('');
  const [idiomasNarrador, setIdiomasNarrador] = useState([]);
  const [nivelIdioma, setNivelIdioma] = useState('');
  const [habilidadPersonajes, setHabilidadPersonajes] = useState('');
  const [habilidadInfantil, setHabilidadInfantil] = useState('');
  const [habilidadEdadAvanzada, setHabilidadEdadAvanzada] = useState('');
  const [observaciones, setObservaciones] = useState('');

  const steps = [
    { title: "Datos Básicos", icon: User },
    { title: "Información del Libro", icon: BookOpen },
    { title: "Selección de Voz", icon: Mic }
  ];

  const handleSubmit = async () => {
    if (!titulo || !autor || !email) {
      toast.error('Por favor completa los campos obligatorios: Título, Autor y Email');
      return;
    }

    setIsLoading(true);

    const formData = {
      // Basic Info
      tipo_formulario: formType,
      titulo,
      autor,
      telefono,
      email,
      registro_obra: registroObra,
      rfc,
      direccion: {
        calle,
        colonia,
        ciudad,
        estado,
        codigo_postal: codigoPostal,
        pais
      },
      // Book Info
      fecha_entrega_pdf: fechaEntregaPdf,
      fecha_lanzamiento: fechaLanzamiento,
      genero_obra: generoObra,
      sinopsis,
      cantidad_hojas: cantidadHojas,
      cantidad_palabras: cantidadPalabras,
      editor,
      secciones: {
        presentacion,
        prologo,
        introduccion,
        citas_inicio: citasInicio,
        dedicatorias,
        elementos_graficos: elementosGraficos,
        palabras_otros_idiomas: palabrasOtrosIdiomas,
        idiomas_incluidos: idiomasIncluidos,
        pronunciacion_correcta: pronunciacionCorrecta,
        contexto_historico: contextoHistorico,
        bibliografia,
        citas_pie: citasPie
      },
      // Voice Selection
      narrador: {
        genero: generoNarrador,
        rango_edad: rangoEdad,
        tono_intencion: tonoIntencion,
        tipo_voz: tipoVoz,
        estilo_lectura: estiloLectura,
        ritmo_lectura: ritmoLectura,
        cantidad_personajes: cantidadPersonajes,
        acentos_personajes: acentosPersonajes,
        especificacion_acentos: especificacionAcentos,
        conocimiento_idioma: conocimientoIdioma,
        idiomas: idiomasNarrador,
        nivel_idioma: nivelIdioma,
        habilidad_personajes: habilidadPersonajes,
        habilidad_infantil: habilidadInfantil,
        habilidad_edad_avanzada: habilidadEdadAvanzada
      },
      observaciones
    };

    try {
      await axios.post(`${API}/metaproduccion`, formData);
      setIsSubmitted(true);
      toast.success('¡Formulario enviado exitosamente!');
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Error al enviar el formulario. Por favor intenta de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-[#080c2d] flex items-center justify-center p-4">
        <div className="bg-[#0f133a]/80 border border-white/10 rounded-2xl p-8 max-w-md text-center">
          <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-green-500" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            ¡Formulario Enviado!
          </h2>
          <p className="text-slate-400 mb-6">
            Hemos recibido tu información de metaproducción. Nuestro equipo revisará los detalles y se pondrá en contacto contigo pronto.
          </p>
          <Button
            onClick={() => window.location.href = '/'}
            className="bg-[#aa2aff] hover:bg-[#7012b2] text-white"
          >
            Volver al Inicio
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#080c2d] bg-pattern">
      {/* Header */}
      <header className="border-b border-white/10 bg-[#0f133a]/80 backdrop-blur-lg">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center justify-center gap-4">
            <img src={VIUBUX_LOGO} alt="Viubux" className="h-8 object-contain" />
            <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Metaproducción
            </h1>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="bg-gradient-to-b from-[#aa2aff]/20 to-transparent py-12 text-center px-4">
        <Sparkles className="w-12 h-12 text-[#aa2aff] mx-auto mb-4" />
        <h2 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          ¡Gracias por iniciar tu proceso!
        </h2>
        <p className="text-slate-400 max-w-xl mx-auto">
          Te invitamos a llenar el siguiente formulario para publicar tu obra en formato de Viubuk y Audiolibro con nosotros.
        </p>
        <p className="text-slate-500 text-sm mt-2">
          Tiempo estimado: 3 minutos
        </p>
      </div>

      {/* Progress Steps */}
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="flex items-center justify-between mb-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const isActive = index === currentStep;
            const isCompleted = index < currentStep;
            
            return (
              <div key={index} className="flex items-center">
                <div className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all ${
                  isActive 
                    ? 'bg-[#aa2aff] text-white' 
                    : isCompleted 
                      ? 'bg-green-500/20 text-green-400 border border-green-500/30' 
                      : 'bg-white/5 text-slate-500 border border-white/10'
                }`}>
                  <Icon className="w-4 h-4" />
                  <span className="text-sm font-medium hidden sm:inline">{step.title}</span>
                  <span className="text-sm font-medium sm:hidden">{index + 1}</span>
                </div>
                {index < steps.length - 1 && (
                  <div className={`w-8 sm:w-16 h-0.5 mx-2 ${
                    isCompleted ? 'bg-green-500' : 'bg-white/10'
                  }`} />
                )}
              </div>
            );
          })}
        </div>

        {/* Form Content */}
        <div className="bg-[#0f133a]/60 backdrop-blur-xl border border-white/5 rounded-2xl p-6 shadow-xl">
          {/* Step 1: Basic Info */}
          {currentStep === 0 && (
            <div className="space-y-6">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-2 rounded-lg bg-gradient-to-br from-[#aa2aff] to-[#7012b2]">
                  <User className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Datos Básicos
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                  <Label className="text-white text-sm mb-2 block">Tipo de Formulario</Label>
                  <div className="flex gap-4">
                    <label className={`flex-1 p-4 rounded-xl border cursor-pointer transition-all ${
                      formType === 'basica' 
                        ? 'border-[#aa2aff] bg-[#aa2aff]/10' 
                        : 'border-white/10 hover:border-white/20'
                    }`}>
                      <input
                        type="radio"
                        name="formType"
                        value="basica"
                        checked={formType === 'basica'}
                        onChange={() => setFormType('basica')}
                        className="hidden"
                      />
                      <span className={`font-medium ${formType === 'basica' ? 'text-[#aa2aff]' : 'text-white'}`}>
                        Básica
                      </span>
                    </label>
                    <label className={`flex-1 p-4 rounded-xl border cursor-pointer transition-all ${
                      formType === 'seleccion_voz' 
                        ? 'border-[#aa2aff] bg-[#aa2aff]/10' 
                        : 'border-white/10 hover:border-white/20'
                    }`}>
                      <input
                        type="radio"
                        name="formType"
                        value="seleccion_voz"
                        checked={formType === 'seleccion_voz'}
                        onChange={() => setFormType('seleccion_voz')}
                        className="hidden"
                      />
                      <span className={`font-medium ${formType === 'seleccion_voz' ? 'text-[#aa2aff]' : 'text-white'}`}>
                        Selección de voz
                      </span>
                    </label>
                  </div>
                </div>

                <TextField label="Título" value={titulo} onChange={setTitulo} placeholder="Título del libro" required />
                <TextField label="Autor" value={autor} onChange={setAutor} placeholder="Nombre del autor" required />
                <TextField label="Teléfono / WhatsApp" value={telefono} onChange={setTelefono} placeholder="+52 555 123 4567" />
                <TextField label="Email" value={email} onChange={setEmail} placeholder="correo@ejemplo.com" type="email" required />
                <TextField label="Registro de la Obra" value={registroObra} onChange={setRegistroObra} placeholder="Número de registro (si aplica)" />
                <TextField label="RFC / TAX ID" value={rfc} onChange={setRfc} placeholder="RFC o identificación fiscal" />
              </div>

              <div className="border-t border-white/10 pt-6 mt-6">
                <h4 className="text-white font-semibold mb-4 flex items-center gap-2">
                  <Building className="w-4 h-4 text-[#aa2aff]" />
                  Dirección Fiscal (Billing Address)
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <TextField label="Calle" value={calle} onChange={setCalle} placeholder="Calle y número" />
                  <TextField label="Colonia" value={colonia} onChange={setColonia} placeholder="Colonia o barrio" />
                  <TextField label="Ciudad" value={ciudad} onChange={setCiudad} placeholder="Ciudad" />
                  <TextField label="Estado" value={estado} onChange={setEstado} placeholder="Estado o provincia" />
                  <TextField label="Código Postal" value={codigoPostal} onChange={setCodigoPostal} placeholder="Código postal" />
                  <SelectField label="País" value={pais} onChange={setPais} options={COUNTRIES} />
                </div>
              </div>
            </div>
          )}

          {/* Step 2: Book Info */}
          {currentStep === 1 && (
            <div className="space-y-6">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-2 rounded-lg bg-gradient-to-br from-[#aa2aff] to-[#7012b2]">
                  <BookOpen className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Información del Libro
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <TextField label="Fecha de entrega de PDF del libro" value={fechaEntregaPdf} onChange={setFechaEntregaPdf} type="date" />
                <TextField label="Fecha deseada de Lanzamiento" value={fechaLanzamiento} onChange={setFechaLanzamiento} type="date" />
                <SelectField label="Género de la obra" value={generoObra} onChange={setGeneroObra} options={GENRES} />
                <TextField label="Cantidad de hojas" value={cantidadHojas} onChange={setCantidadHojas} placeholder="Ej: 250" type="number" />
                <TextField label="Cantidad de palabras" value={cantidadPalabras} onChange={setCantidadPalabras} placeholder="Ej: 50000" type="number" />
                <TextField label="Editor" value={editor} onChange={setEditor} placeholder="Nombre del editor (si aplica)" />
              </div>

              <TextAreaField label="Sinópsis" value={sinopsis} onChange={setSinopsis} placeholder="Escribe una breve sinopsis de la obra..." rows={4} />

              <div className="border-t border-white/10 pt-6">
                <h4 className="text-white font-semibold mb-4">Secciones del Libro</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <SelectField label="Presentación" value={presentacion} onChange={setPresentacion} options={SECTION_OPTIONS} />
                  <SelectField label="Prólogo" value={prologo} onChange={setPrologo} options={SECTION_OPTIONS} />
                  <SelectField label="Introducción" value={introduccion} onChange={setIntroduccion} options={SECTION_OPTIONS} />
                  <SelectField label="Citas de inicio" value={citasInicio} onChange={setCitasInicio} options={SECTION_OPTIONS} />
                  <SelectField label="Dedicatorias" value={dedicatorias} onChange={setDedicatorias} options={SECTION_OPTIONS} />
                  <SelectField label="Bibliografía" value={bibliografia} onChange={setBibliografia} options={SECTION_OPTIONS} />
                  <SelectField label="Citas al pie de página" value={citasPie} onChange={setCitasPie} options={SECTION_OPTIONS} />
                  <SelectField label="Elementos gráficos (tablas, diagramas)" value={elementosGraficos} onChange={setElementosGraficos} options={GRAPHIC_OPTIONS} />
                </div>
              </div>

              <div className="border-t border-white/10 pt-6">
                <h4 className="text-white font-semibold mb-4">Idiomas y Contexto</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <SelectField 
                    label="Palabras y/o nombres en otros idiomas" 
                    value={palabrasOtrosIdiomas} 
                    onChange={setPalabrasOtrosIdiomas} 
                    options={[{ value: "si", label: "Si hay" }, { value: "no", label: "No hay" }]} 
                  />
                  {palabrasOtrosIdiomas === 'si' && (
                    <>
                      <div className="space-y-2">
                        <Label className="text-white text-sm">Idiomas incluidos en la obra</Label>
                        <div className="flex flex-wrap gap-2">
                          {LANGUAGES.map(lang => (
                            <label key={lang} className={`px-3 py-1 rounded-full border cursor-pointer text-sm transition-all ${
                              idiomasIncluidos.includes(lang) 
                                ? 'border-[#aa2aff] bg-[#aa2aff]/20 text-[#aa2aff]' 
                                : 'border-white/20 text-slate-400 hover:border-white/40'
                            }`}>
                              <input
                                type="checkbox"
                                className="hidden"
                                checked={idiomasIncluidos.includes(lang)}
                                onChange={() => {
                                  if (idiomasIncluidos.includes(lang)) {
                                    setIdiomasIncluidos(idiomasIncluidos.filter(l => l !== lang));
                                  } else {
                                    setIdiomasIncluidos([...idiomasIncluidos, lang]);
                                  }
                                }}
                              />
                              {lang}
                            </label>
                          ))}
                        </div>
                      </div>
                      <div className="md:col-span-2">
                        <TextAreaField 
                          label="Pronunciación correcta de dichas palabras y/o nombres" 
                          value={pronunciacionCorrecta} 
                          onChange={setPronunciacionCorrecta} 
                          placeholder="Especifica la pronunciación correcta..."
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className="mt-4">
                  <TextAreaField label="Contexto histórico" value={contextoHistorico} onChange={setContextoHistorico} placeholder="Describe el contexto histórico relevante..." />
                </div>
              </div>
            </div>
          )}

          {/* Step 3: Voice Selection */}
          {currentStep === 2 && (
            <div className="space-y-6">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-2 rounded-lg bg-gradient-to-br from-[#aa2aff] to-[#7012b2]">
                  <Mic className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Selección de Voz del Narrador
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <SelectField label="Género del narrador" value={generoNarrador} onChange={setGeneroNarrador} options={NARRATOR_GENDER} />
                <SelectField label="Rango de edad" value={rangoEdad} onChange={setRangoEdad} options={AGE_RANGES} />
                <SelectField label="Tono e intención" value={tonoIntencion} onChange={setTonoIntencion} options={VOICE_TONES} />
                <SelectField label="Tipo de voz" value={tipoVoz} onChange={setTipoVoz} options={VOICE_TYPES} />
                <SelectField label="Estilo de lectura" value={estiloLectura} onChange={setEstiloLectura} options={READING_STYLES} />
                <SelectField label="Ritmo de lectura" value={ritmoLectura} onChange={setRitmoLectura} options={READING_RHYTHMS} />
              </div>

              <div className="border-t border-white/10 pt-6">
                <h4 className="text-white font-semibold mb-4">Personajes</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <SelectField 
                    label="¿Cantidad de personajes?" 
                    value={cantidadPersonajes} 
                    onChange={setCantidadPersonajes} 
                    options={["1", "2", "3", "4", "5+"]} 
                  />
                  <SelectField 
                    label="Acentos en personajes específicos" 
                    value={acentosPersonajes} 
                    onChange={setAcentosPersonajes} 
                    options={[{ value: "si", label: "Si hay" }, { value: "no", label: "No hay" }]} 
                  />
                  {acentosPersonajes === 'si' && (
                    <div className="md:col-span-2">
                      <TextAreaField 
                        label="Especifique cuales personajes hablan con cual acento" 
                        value={especificacionAcentos} 
                        onChange={setEspecificacionAcentos} 
                        placeholder="Ej: Personaje Juan - acento mexicano, Personaje María - acento español..."
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="border-t border-white/10 pt-6">
                <h4 className="text-white font-semibold mb-4">Conocimientos del Narrador</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <SelectField 
                    label="Conocimiento de algún idioma específico" 
                    value={conocimientoIdioma} 
                    onChange={setConocimientoIdioma} 
                    options={[{ value: "si", label: "Si, especificaciones abajo" }, { value: "no", label: "No" }]} 
                  />
                  {conocimientoIdioma === 'si' && (
                    <>
                      <SelectField 
                        label="Nivel de conocimiento requerido" 
                        value={nivelIdioma} 
                        onChange={setNivelIdioma} 
                        options={KNOWLEDGE_LEVELS} 
                      />
                      <div className="md:col-span-2 space-y-2">
                        <Label className="text-white text-sm">Idiomas requeridos</Label>
                        <div className="flex flex-wrap gap-2">
                          {LANGUAGES.map(lang => (
                            <label key={lang} className={`px-3 py-1 rounded-full border cursor-pointer text-sm transition-all ${
                              idiomasNarrador.includes(lang) 
                                ? 'border-[#aa2aff] bg-[#aa2aff]/20 text-[#aa2aff]' 
                                : 'border-white/20 text-slate-400 hover:border-white/40'
                            }`}>
                              <input
                                type="checkbox"
                                className="hidden"
                                checked={idiomasNarrador.includes(lang)}
                                onChange={() => {
                                  if (idiomasNarrador.includes(lang)) {
                                    setIdiomasNarrador(idiomasNarrador.filter(l => l !== lang));
                                  } else {
                                    setIdiomasNarrador([...idiomasNarrador, lang]);
                                  }
                                }}
                              />
                              {lang}
                            </label>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="border-t border-white/10 pt-6">
                <h4 className="text-white font-semibold mb-4">Habilidades Especiales</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <SelectField 
                    label="Habilidad para representar diversos personajes" 
                    value={habilidadPersonajes} 
                    onChange={setHabilidadPersonajes} 
                    options={[{ value: "si", label: "Si" }, { value: "no", label: "No" }]} 
                  />
                  <SelectField 
                    label="Habilidad para recrear voces infantiles" 
                    value={habilidadInfantil} 
                    onChange={setHabilidadInfantil} 
                    options={[{ value: "si", label: "Si" }, { value: "no", label: "No" }]} 
                  />
                  <SelectField 
                    label="Habilidad para recrear voces de edad avanzada" 
                    value={habilidadEdadAvanzada} 
                    onChange={setHabilidadEdadAvanzada} 
                    options={[{ value: "si", label: "Si" }, { value: "no", label: "No" }]} 
                  />
                </div>
              </div>

              <TextAreaField 
                label="Observaciones adicionales" 
                value={observaciones} 
                onChange={setObservaciones} 
                placeholder="Cualquier otra información relevante para la producción de tu audiolibro..."
                rows={4}
              />
            </div>
          )}

          {/* Navigation Buttons */}
          <div className="flex justify-between mt-8 pt-6 border-t border-white/10">
            <Button
              onClick={prevStep}
              disabled={currentStep === 0}
              variant="outline"
              className="border-slate-600 text-slate-300 hover:bg-white/5 disabled:opacity-30"
            >
              <ChevronLeft className="w-4 h-4 mr-2" />
              Regresar
            </Button>
            
            {currentStep < steps.length - 1 ? (
              <Button
                onClick={nextStep}
                className="bg-[#aa2aff] hover:bg-[#7012b2] text-white"
              >
                Siguiente
                <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
            ) : (
              <Button
                onClick={handleSubmit}
                disabled={isLoading}
                className="bg-gradient-to-r from-[#003fdd] to-[#aa2aff] hover:from-[#aa2aff] hover:to-[#003fdd] text-white"
              >
                {isLoading ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    Enviando...
                  </>
                ) : (
                  <>
                    <Send className="w-4 h-4 mr-2" />
                    Enviar
                  </>
                )}
              </Button>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-white/10 bg-[#0f133a]/50 py-6 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} Viubux. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default MetaproduccionForm;
